import { useState } from "react";
import { useAuth } from "../../lib/AuthContext";
import { CircleNotch, PaperPlaneRight, Warning } from "@phosphor-icons/react";
import { Button } from "../../components/ui/button";

export default function AdminEmail() {
  const { authFetch } = useAuth();

  return (
    <div className="p-6 lg:p-8 max-w-3xl mx-auto" data-testid="admin-email">
      <h1 className="font-display font-bold text-2xl text-slate-900 mb-6">Email Users</h1>

      <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 mb-6">
        <div className="flex items-start gap-3">
          <Warning className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" weight="fill" />
          <div>
            <p className="text-sm font-medium text-amber-800">SendGrid Integration Required</p>
            <p className="text-sm text-amber-700 mt-1">
              Email functionality requires a SendGrid API key. Add <code className="bg-amber-100 px-1 rounded text-xs">SENDGRID_API_KEY</code> to
              the backend environment variables, then this feature will be activated.
            </p>
          </div>
        </div>
      </div>

      {/* Placeholder compose form */}
      <div className="bg-white rounded-xl border border-slate-200 p-6 opacity-60 pointer-events-none">
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1">To</label>
            <select className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2 bg-white" disabled>
              <option>All users</option>
              <option>Free tier users</option>
              <option>Pro tier users</option>
              <option>Team tier users</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1">Subject</label>
            <input type="text" placeholder="Email subject..." className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2" disabled />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1">Message</label>
            <textarea rows={6} placeholder="Write your message..." className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2" disabled />
          </div>
          <Button disabled className="bg-teal text-white rounded-lg gap-2 opacity-50">
            <PaperPlaneRight className="w-4 h-4" /> Send Email
          </Button>
        </div>
      </div>
    </div>
  );
}
